<template>
  <div class="container">
    <div class="col-md-10 col-sm-10 mx-auto">
      <div v-if="loading">
        <h3>Loading...</h3>
        <div v-if="loading" class="spinner-border text-secondary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div v-if="!loading">
        <div v-if="formState == 'finishedMatch'">
          <h3>Thank you for updating that, would you like to:</h3>
          <div class="form-inline">
            <button type="button" @click="$router.push('/submit')" class="btn btn-secondary">Submit another key</button>
            <div style="width:8px;height:auto;display:inline-block;" />
            <p class="form-text">or</p>
            <div style="width:8px;height:auto;display:inline-block;" />
            <button type="button" @click="$router.push('/game/'+$route.params.gameId)" class="btn btn-secondary">View the game's page</button>
          </div>
        </div>
        <div v-if="formState == 'updateMatch'">
          <h3>Find a match for {{ gameInfo.name }} in the <a href="https://rawg.io/">RAWG</a> database</h3>
          <div v-if="errorMessage">
            <p class="text-danger">{{ errorMessage }}</p>
          </div>
          <div class="pb-2">
            <form>
              <div class="form-inline">
                <input
                  type="text"
                  class="form-control"
                  id="name"
                  placeholder="Search for a game"
                  v-model="searchQuery"
                >
                <div style="width:8px;height:auto;display:inline-block;" />
                <button type="submit" @click="getPotentialMatches()" class="btn btn-secondary">Search</button>
                <div style="width:20px;height:auto;display:inline-block;" />
                <button type="submit" @click="submitMatch()" class="btn btn-success">Confirm match</button>
                <div style="width:20px;height:auto;display:inline-block;" />
                <button type="button" @click="formState = 'finishedMatch'" class="btn btn-warning">Skip matching</button>
              </div>
            </form>
          </div>
          <div v-if="potentialMatches.length">
            <div class="table-responsive" style="overflow: auto; height: 600px;">
              <table class="table table-sm table-hover table-striped">
                <thead>
                  <tr>
                    <th scope="col">Name</th>
                    <th scope="col">Image</th>
                    <th scope="col">Release</th>
                    <th scope="col">Link</th>
                    <th scope="col">Select</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(game, index) in potentialMatches" :key="index">
                    <td>{{ game.name }}</td>
                    <td><img :src="game.background_image"/></td>
                    <td>{{ game.released }}</td>
                    <td><a :href="'https://rawg.io/games/' + game.slug" target="_blank">RAWG Link</a></td>
                    <td v-if="selectedGame != game"><button type="button" @click="select(game)" class="btn btn-secondary">Select this title</button></td>
                    <td v-if="selectedGame == game"><span style="color: green;"><font-awesome-icon icon="check-circle" fixed-width />    Selected</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import axios from 'axios'

export default {
  name: 'match',
  props: ['user'],
  data() {
    return {
      formState: 'updateMatch',
      gameInfo: {},
      potentialMatches: [],
      searchQuery: '',
      selectedMatch: 0,
      loading: true,
      errorMessage: '',
      selectedGame: {}
    }
  },
  methods: {
    buildSearchUrl() {
      var params = '&search=' + this.searchQuery
      return encodeURI('https://api.rawg.io/api/games?key=9b3d6882da4d45c3b7252e508a223a6b&search_precise=true&exclude_additons=true' + params)
    },
    getPotentialMatches() {
      this.selectedGame = {}

      // Wait until the user actually enters a search
      if (!this.searchQuery || this.searchQuery == '') {
        return
      }

      axios.get(this.buildSearchUrl())
      .then( response => {
        this.potentialMatches = response.data.results.filter((game) => {
          return game.added != 0
        })
        this.loading = false
      })
      .catch( error => {
        this.errorMessage = error
        this.loading = false
      })
    },
    select(game) {
      this.selectedGame = game
    },
    submitMatch() {
      // Verify user has selected a match
      if (!this.selectedGame) {
        this.errorMessage = 'You must select a match to continue'
        window.scrollTo(0,0)
        return
      }

      // Submit mutation to update dynamo record for game
      this.loading = true
      var input = {
        KeyId: this.$route.params.gameId,
        rawgId: this.selectedGame.id,
        genres: null,
        metacritic: null,
        released: null
      }
      if (this.selectedGame.genres && this.selectedGame.genres.length > 0){
        input.genres = this.selectedGame.genres.map(function(g){return g.name}).join(', ')
      }
      if (this.selectedGame.metacritic) {
        input.metacritic = this.selectedGame.metacritic
      }
      if (this.selectedGame.released) {
        input.released = this.selectedGame.released
      }
      this.$apollo.mutate({
        mutation: gql`mutation ($KeyId: ID!, $rawgId: Int!, $genres: String, $metacritic: Int, $released: String) {
          updateRawgId(KeyId: $KeyId, rawgId: $rawgId, genres: $genres, metacritic: $metacritic, released: $released) {
            KeyId
            name
            rawgId
            genres
            metacritic
            released
          }
        }`,
        variables: input
      }).then(() => {
        // Update state variables
        this.loading = false
        this.formState = 'finishedMatch'
      }).catch((error) => {
        this.loading = false
        // Save error message
        this.errorMessage = error
        // Scroll back to the error (have to wait until the DOM gets re-rendered)
        this.$nextTick(function(){
          window.scrollTo(0,0)
        })
      })
    }
  },
  apollo: {
    gameInfo: {
      query: gql`
        query getKey ($KeyId: ID!) {
          gameInfo: getKey(KeyId: $KeyId) {
            KeyId
            name
            notes
            submitter
            submitTime
          }
        }`,
      variables () {
        return { KeyId: this.$route.params.gameId }
      },
      result () {
        this.searchQuery = this.gameInfo.name
        this.getPotentialMatches()
      }
    }
  }
}
</script>

<style>
img {
    width:100%;
    max-width:400px;
}
</style>